import { css, CSSResult } from 'lit'
import { csBorder } from '@cloudsuite/mosaic-shared/styles/globals.style.js'


export const style: CSSResult = css`
  :host {
    flex: 1;
  }
  
  .csc-store-map {
    border-radius: ${csBorder.radiusSubtle};
    overflow: hidden;
  }
  
  gmp-advanced-marker:not(:defined) {
    display: none;
  }
`
